<template>
    <section>
        <el-tabs type="border-card" class="border-card">
            <el-tab-pane label="设备">
                <Device></Device>
            </el-tab-pane>
            <el-tab-pane label="会话">
                <Session></Session>
            </el-tab-pane>
        </el-tabs>
    </section>
</template>
<script>
    import Device from "./Device.vue"
    import Session from "./Session.vue"
    export default {
        components: {
            Device,
            Session
        },
        data() {
            return {}
        },
        methods: {

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/device/DeviceSessionManage.vue